import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import type { StripeAccountStatusType } from 'types/entityTypes/StripeAccountStatusType';

type AccountStatusSectionProps = {
  status: StripeAccountStatusType | undefined;
};

function AccountStatusSection({ status }: AccountStatusSectionProps) {
  const stripeUrl = 'https://dashboard.stripe.com/';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        gap: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: '15px',
        }}
      >
        Status
      </Typography>
      <Box
        sx={{
          height: '50px',
          bgcolor: (theme) => theme.palette.primary.light,
          borderRadius: '15px',
          display: 'flex',
          alignItems: 'center',
          padding: '25px',
        }}
        gap={2}
      >
        <Box
          width={'50px'}
          height={'50px'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          borderRadius={'12px'}
          sx={{ bgcolor: (theme) => theme.palette.primary.main }}
        >
          <Avatar
            src={status?.attributes.iconURL}
            sx={{ width: 30, height: 30 }}
            alt={status?.attributes.name || 'Status'}
          />
        </Box>
        <Box>
          <a
            href={stripeUrl}
            target='_blank'
            rel='noopener noreferrer'
            style={{
              color: '#6267AC',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
          >
            <Typography
              component='span'
              color={'#6267AC'}
              variant='h5'
              fontSize={'1.5rem'}
              fontWeight={'bold'}
              sx={{
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {status?.attributes.name || 'Active'}
            </Typography>
          </a>
        </Box>
      </Box>
    </Box>
  );
}

export default AccountStatusSection;
